<script>
  import { onMount } from 'svelte';
  import { token, ui } from '../stores';
  import Icon from './Icon.svelte';
  import cookie from '../helpers/cookie.js';

  import {
    mdiMagnify,
    mdiMagnifyMinus,
    mdiMagnifyPlus,
    mdiVolumeHigh,
    mdiVolumeOff,
    mdiMicrophone,
    mdiMicrophoneOff,
    mdiLocationExit,
  } from '@mdi/js';

  let zoomButton = 0;
  let chatterButton = 'on';
  let micButton = 'on';
  let isHovered = false;
  let justClicked;

  $: theme = $ui.theme || $ui.defaultTheme;

  $: {
    // Set the zoom button whenever $ui.zoomLevel.
    zoomButton = $ui.zoomLevel;
  }

  $: if (!$ui.toolbarIsHovered) {
    setMouseOut();
  }

  function setMouseOver(button) {
    isHovered = button;
  }

  function setMouseOut() {
    isHovered = false;
    justClicked = false;
  }

  function setZoomLevel() {
    isHovered = false;
    justClicked = 'zoom';
    // Zoom out from default?
    if (!$token.clusterId && $ui.zoomLevel == 0) $ui.zoomLevel = -1;
    // Zoom back into default?
    else if (!$token.clusterId && $ui.zoomLevel == -1) $ui.zoomLevel = 0;
    // Zoom out from cluster?
    else if ($token.clusterId && $ui.zoomLevel == 1) $ui.zoomLevel = -1;
    // Zoom back into cluster?
    else if ($token.clusterId && $ui.zoomLevel == -1) $ui.zoomLevel = 1;
  }

  function toggleChatter() {
    isHovered = false;
    justClicked = 'chatter';
    ui.toggleChatter();
    const isActive = cookie.get('chatterIsActive') != 'false';
    chatterButton = isActive ? 'on' : 'off';
  }

  function toggleMic() {
    isHovered = false;
    justClicked = 'mic';
    micButton = micButton == 'off' ? 'on' : 'off';
    token.toggleMic();
  }

  onMount(() => {
    const isActive = cookie.get('chatterIsActive') != 'false';
    chatterButton = isActive ? 'on' : 'off';
  });
</script>

<style>
  button {
    @apply text-xs outline-none p-2;
  }
</style>

<div
  id="dashboard"
  class="flex justify-between items-center w-full h-16 pt-2"
  style="background:{theme.dashboard.background}">
  {#if $token.stream}
    <div id="left-group">
      <!-- Zoom Button -->
      <button
        on:mouseover="{() => (isHovered = 'zoom')}"
        on:mouseout="{() => (isHovered = false)}"
        on:click="{setZoomLevel}">
        {#if zoomButton == 0}
          <div class:opacity-50="{isHovered != 'zoom' || justClicked == 'zoom'}">
            <Icon path="{mdiMagnify}" style="color: #FFF; width: 4rem" />
            Zoom
          </div>
        {:else if zoomButton == 1}
          <Icon path="{mdiMagnifyPlus}" style="color: #FFF; width: 4rem" />
          Zoom
        {:else if zoomButton == -1}
          <Icon path="{mdiMagnifyMinus}" style="color: #FFF; width: 4rem" />
          Zoom
        {/if}
      </button>

      <!-- Chatter Button -->
      <button
        on:mouseover="{() => setMouseOver('chatter')}"
        on:mouseout="{() => setMouseOver(false)}"
        on:click="{toggleChatter}">
        {#if chatterButton == 'on'}
          <Icon path="{mdiVolumeHigh}" style="color: #FFF; width: 4rem" />
          Chatter
        {:else}
          <div class:opacity-50="{isHovered != 'chatter' || justClicked == 'chatter'}">
            <Icon path="{mdiVolumeOff}" style="color: #FFF; width: 4rem" />
            Chatter
          </div>
        {/if}
      </button>

      <!-- Mic Button -->
      <button
        on:mouseover="{() => setMouseOver('mic')}"
        on:mouseout="{() => setMouseOver(false)}"
        on:click="{toggleMic}">
        {#if micButton == 'on'}
          <Icon path="{mdiMicrophone}" style="color: #FFF; width: 4rem" />
          Mic
        {:else}
          <div class:opacity-50="{isHovered != 'mic' || justClicked == 'mic'}">
            <Icon path="{mdiMicrophoneOff}" style="color: #FFF; width: 4rem" />
            Mic
          </div>
        {/if}
      </button>
    </div>

    <!-- Exit Button -->
    <div id="right-group">
      <button on:click="{() => location.reload()}"><Icon
          path="{mdiLocationExit}"
          style="color: #FFF; width: 4rem" />Exit</button>
    </div>
  {:else}
    <div></div>
    <div>
      <!--
        <a
          href="mailto:info@minglespace.co"
          class="mt-0 bg-transparent font-bold"
          style="color:{theme.buttonSecondary.text}">
          info@minglespace.co
        </a>
      -->
    </div>
    <div></div>
  {/if}
</div>
